"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridUtils = exports.PriceCheckType = exports.PriceNonComplianceType = exports.queryGridMoonStrategy = exports.OrdersTypeUsingShortRunningTime = void 0;
const decimal_js_1 = __importDefault(require("decimal.js"));
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const interface_1 = require("../interface/interface");
const SimpleTrading_1 = require("../Trading/SimpleTrading");
const NumberTradeUtils_1 = require("./NumberTradeUtils");
const TradeErrorConstants_1 = require("./TradeErrorConstants");
// 使用简略版的运行时常的机器人类型
exports.OrdersTypeUsingShortRunningTime = [
    TradeAPILib_1.ExchangeOrderType.gridV5,
    // 比特币天地单
    // 以太币天地单
    // EB天地单
    TradeAPILib_1.ExchangeOrderType.gridV4Futures,
    TradeAPILib_1.ExchangeOrderType.martingale,
    // 追踪马丁
    TradeAPILib_1.ExchangeOrderType.SR,
    TradeAPILib_1.ExchangeOrderType.ig,
    TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid,
    TradeAPILib_1.ExchangeOrderType.gridShort,
    TradeAPILib_1.ExchangeOrderType.futures_smart_trade,
    TradeAPILib_1.ExchangeOrderType.smartTrade,
    TradeAPILib_1.ExchangeOrderType.trailingSell,
    TradeAPILib_1.ExchangeOrderType.trailingBuy,
    TradeAPILib_1.ExchangeOrderType.SC,
    TradeAPILib_1.ExchangeOrderType.aip,
    TradeAPILib_1.ExchangeOrderType.enhanced_aip,
    TradeAPILib_1.ExchangeOrderType.twap,
    TradeAPILib_1.ExchangeOrderType.SL_Pro,
    TradeAPILib_1.ExchangeOrderType.copy_bot,
    // 跟单机器人
    TradeAPILib_1.ExchangeOrderType.futures_martingale, // 合约马丁
];
// 价格比例上限 和 价格比例下限， 用于对比用户设置的价格值与当前价格的距离
const UP_PRICE_RATIO = 10;
const DOWN_PRICE_RATIO = 0.1;
const moonStrategy = {
    "BTC/USDT": {
        symbol: "BTC/USDT",
        base: "BTC",
        quote: "USDT",
        bottom: "6000",
        top: "60000",
        count: "500",
        grid_type: "arithmetic",
        use_mcoin_limit: "3000",
    },
    "ETH/USDT": {
        symbol: "ETH/USDT",
        base: "ETH",
        quote: "USDT",
        bottom: "1000",
        top: "10000",
        count: "500",
        grid_type: "arithmetic",
    },
    "ETH/BTC": {
        symbol: "ETH/BTC",
        base: "ETH",
        quote: "BTC",
        bottom: "0.04",
        top: "0.35",
        count: "500",
        grid_type: "arithmetic",
    },
};
/**
 * 获取天地单策略配置
 * @param symbol
 */
const queryMoonStrategyData = () => {
    const configHost = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().CONFIG_HOST;
    return trade_utils_lib_1.ObservableUtils.get(`${configHost}/pionex_strategy_param.json`, null, { "Cache-Control": "max-age=0" });
};
const queryGridMoonStrategy = (symbol) => {
    return queryMoonStrategyData().pipe((0, operators_1.map)((data) => {
        var _a;
        const item = (_a = data === null || data === void 0 ? void 0 : data.moon) === null || _a === void 0 ? void 0 : _a[symbol];
        if (item) {
            return item;
        }
        throw "not find data: " + JSON.stringify(data);
    }));
};
exports.queryGridMoonStrategy = queryGridMoonStrategy;
var PriceNonComplianceType;
(function (PriceNonComplianceType) {
    PriceNonComplianceType[PriceNonComplianceType["topNonCompliance"] = 0] = "topNonCompliance";
    PriceNonComplianceType[PriceNonComplianceType["bottomNonCompliance"] = 1] = "bottomNonCompliance";
    PriceNonComplianceType[PriceNonComplianceType["rangeNonCompliance"] = 2] = "rangeNonCompliance";
    // 止盈过远
    PriceNonComplianceType[PriceNonComplianceType["tpNonCompliance"] = 3] = "tpNonCompliance";
    // 止损过远
    PriceNonComplianceType[PriceNonComplianceType["slNonCompliance"] = 4] = "slNonCompliance";
    // 触发价格过远
    PriceNonComplianceType[PriceNonComplianceType["triggerPriceNonCompliance"] = 5] = "triggerPriceNonCompliance";
})(PriceNonComplianceType || (exports.PriceNonComplianceType = PriceNonComplianceType = {}));
var PriceCheckType;
(function (PriceCheckType) {
    PriceCheckType[PriceCheckType["tpPrice"] = 0] = "tpPrice";
    PriceCheckType[PriceCheckType["slPrice"] = 1] = "slPrice";
    PriceCheckType[PriceCheckType["triggerPrice"] = 2] = "triggerPrice";
    PriceCheckType[PriceCheckType["rangePrice"] = 3] = "rangePrice";
})(PriceCheckType || (exports.PriceCheckType = PriceCheckType = {}));
exports.GridUtils = {
    checkGridBalance(symbol, baseAvailable, quoteAvailable, high, low, perVolume, gridCount, tradeApi, market) {
        const precision = {
            amount: symbol.amount,
            price: symbol.precision,
        };
        const limit = symbol.limit;
        const body = {
            got_base_amount: `${baseAvailable}`,
            got_quote_amount: `${quoteAvailable}`,
            market: market,
            base: symbol.base,
            quote: symbol.quote,
            top: `${high}`,
            bottom: `${low}`,
            per_volume: `${perVolume}`,
            row_cnt: `${gridCount}`,
            precision: precision,
            limits: limit,
        };
        return (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.checkGridRequireBalance(body), {
            maxRetryCount: 3,
        });
    },
    processCheckGridBalanceResult(result, symbol, baseBalance, quoteBalance, tradeApi, $st, price) {
        let errorMsg = "";
        let needBalance = false;
        let balanceMsg = "";
        if (!result.enough) {
            errorMsg = result.errMsg
                ? exports.GridUtils.transRequireBalanceErrMsg(result.errMsg, symbol.baseDisplay, symbol.quote, $st)
                : TradeErrorConstants_1.TradeErrorConstants.gridUnknownError($st);
            return {
                canCreate: false,
                error: errorMsg,
                needBalance: false,
                balanceMsg: "",
            };
        }
        else {
            const myBaseBalance = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(baseBalance, symbol.amount).toNumber();
            const myQuoteBalance = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(quoteBalance, symbol.precision).toNumber();
            const needBaseBalance = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(result.needBase, symbol.amount, decimal_js_1.default.ROUND_CEIL).toNumber();
            const needQuoteBalance = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(result.needQuote, symbol.precision, decimal_js_1.default.ROUND_CEIL).toNumber();
            if (myBaseBalance < needBaseBalance) {
                const baseOffset = NumberTradeUtils_1.NumberTradeUtils.toAmountBySymbol(tradeApi, needBaseBalance - myBaseBalance, symbol, decimal_js_1.default.ROUND_CEIL);
                const msg = TradeErrorConstants_1.TradeErrorConstants.gridBalanceOrderBuyTip(baseOffset + ` ${symbol.baseDisplay}`, $st);
                needBalance = true;
                balanceMsg = msg;
            }
            else if (myQuoteBalance < needQuoteBalance) {
                const quoteOffset = needQuoteBalance - myQuoteBalance;
                let needToSellBase = "--";
                if (price) {
                    needToSellBase = NumberTradeUtils_1.NumberTradeUtils.toAmountBySymbol(tradeApi, quoteOffset / price, symbol, decimal_js_1.default.ROUND_UP);
                }
                const msg = TradeErrorConstants_1.TradeErrorConstants.gridBalanceOrderSellTip(needToSellBase + ` ${symbol.baseDisplay}`, $st);
                needBalance = true;
                balanceMsg = msg;
            }
        }
        const checkBalanceResult = {
            canCreate: result.enough,
            error: errorMsg,
            needBalance: needBalance,
            balanceMsg: balanceMsg,
        };
        return checkBalanceResult;
    },
    requireGridPerVolume(tradeApi, high, low, gridCount, symbol, balancePercent, baseBalance, quoteBalance, market, $st) {
        return (0, rxjs_1.of)(0)
            .pipe((0, operators_1.map)(() => {
            if (balancePercent > 0.95) {
                throw TradeErrorConstants_1.TradeErrorConstants.girdAmountPercentRatherThan95($st);
            }
            if (!high || !low) {
                return TradeErrorConstants_1.TradeErrorConstants.inputPriceRange($st);
            }
            if (!gridCount) {
                return TradeErrorConstants_1.TradeErrorConstants.inputGridCount($st);
            }
            if (low >= high) {
                throw TradeErrorConstants_1.TradeErrorConstants.gridLowNeedLowerThanHigh($st);
            }
            if (gridCount < 2 || gridCount > 99) {
                return TradeErrorConstants_1.TradeErrorConstants.gridCount99RangeError($st);
            }
            if (!baseBalance && !quoteBalance) {
                return TradeErrorConstants_1.TradeErrorConstants.balanceNotEnough($st);
            }
            const request = {
                balance_percent: `${balancePercent}`,
                got_base_amount: `${baseBalance}`,
                got_quote_amount: `${quoteBalance}`,
                market: market,
                base: symbol.base,
                quote: symbol.quote,
                top: high,
                bottom: low,
                per_volume: 0,
                row_cnt: gridCount,
                precision: symbol.precision !== undefined ? symbol.precision : 4,
                limits: symbol.limit,
            };
            return request;
        }))
            .pipe((0, operators_1.mergeMap)((params) => {
            return (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.requireGridPervolume(params), {
                maxRetryCount: 3,
            });
        }));
    },
    getProfitPerGrid(high, low, count, feeRate) {
        if (!high || !low || !count || low >= high || count < 2) {
            return undefined;
        }
        const priceStep = (high - low) / (count - 1);
        let priceBelow = 0;
        let minProfit = 0;
        let maxProfit = 0;
        for (let price = low; price <= high; price += priceStep) {
            if (priceBelow !== 0) {
                if (maxProfit === 0) {
                    maxProfit = (price * (1 - feeRate) - priceBelow * (1 + feeRate)) / priceBelow;
                }
                minProfit = (price * (1 - feeRate) - priceBelow * (1 + feeRate)) / priceBelow;
            }
            priceBelow = price;
        }
        return [minProfit, maxProfit];
    },
    useTotalBalance(baseBalance, quoteBalance, price) {
        return (0, react_1.useMemo)(() => {
            return new trade_utils_lib_1.SafeDecimal(baseBalance).mul(new trade_utils_lib_1.SafeDecimal(price)).add(new trade_utils_lib_1.SafeDecimal(quoteBalance)).toNumber();
        }, [baseBalance, quoteBalance, price]);
    },
    useBalanceDisplay(tradeApi, baseBalance, quoteBalance, total, symbol) {
        return (0, react_1.useMemo)(() => {
            const totalStr = `= ${NumberTradeUtils_1.NumberTradeUtils.toPriceBySymbol(tradeApi, total, symbol)} ${symbol.quote}`;
            const descStr = `(${NumberTradeUtils_1.NumberTradeUtils.toAmountBySymbol(tradeApi, baseBalance, symbol)}${symbol.baseDisplay}+` +
                `${NumberTradeUtils_1.NumberTradeUtils.toPriceBySymbol(tradeApi, quoteBalance, symbol)}${symbol.quote})`;
            return [totalStr, descStr];
        }, [baseBalance, quoteBalance, total, symbol]);
    },
    useGridAIStrategy(tradeApi, base, quote, market) {
        const [item, setItem] = (0, react_1.useState)(undefined);
        const [loading, setLoading] = (0, react_1.useState)(true);
        const [error, setError] = (0, react_1.useState)("");
        (0, react_1.useEffect)(() => {
            setLoading(true);
            const retryOb = (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.requireAIStrategyWithSymbol(market, base, quote), {
                maxRetryCount: 3,
            }).subscribe({
                next: (data) => {
                    const aiItem = data;
                    setItem(aiItem);
                    setError("");
                    setLoading(false);
                },
                error: (error) => {
                    setError(JSON.stringify(error) || `${error}`);
                    setLoading(false);
                },
            });
            return () => retryOb && retryOb.unsubscribe();
        }, [base, quote]);
        return [item, loading, error];
    },
    /**
     * 获取天地单策略配置
     * @param symbol
     */
    useMoonStrategy(symbol) {
        const [moonStrategyItem, setMoonStrategyItem] = (0, react_1.useState)();
        (0, react_1.useEffect)(() => {
            setMoonStrategyItem(undefined);
            const LocalStorageKey = "pionex_strategy_param_" + symbol;
            const promise = (0, trade_utils_lib_1.getTradeDependencyInstance)().getLocalStorage().getItem(LocalStorageKey);
            const subscription = (0, rxjs_1.from)(promise)
                .pipe((0, operators_1.map)((data) => {
                if (!data) {
                    return null;
                }
                try {
                    return JSON.parse(data);
                }
                catch (e) {
                    return null;
                }
            }))
                .pipe((0, operators_1.mergeMap)((data) => {
                var _a;
                let item = (_a = data === null || data === void 0 ? void 0 : data.moon) === null || _a === void 0 ? void 0 : _a[symbol];
                if (!item) {
                    item = moonStrategy[symbol];
                }
                if (item) {
                    setMoonStrategyItem(item);
                }
                return queryMoonStrategyData();
            }))
                .subscribe({
                next: (data) => {
                    var _a;
                    (0, trade_utils_lib_1.getTradeDependencyInstance)().getLocalStorage().setItem(LocalStorageKey, JSON.stringify(data));
                    const item = (_a = data === null || data === void 0 ? void 0 : data.moon) === null || _a === void 0 ? void 0 : _a[symbol];
                    if (item) {
                        setMoonStrategyItem(item);
                    }
                },
                error: (error) => { },
            });
            return () => subscription.unsubscribe();
        }, [symbol]);
        return moonStrategyItem;
    },
    useMinTotalBalance(aiItem, symbol, ticker, baseBalance, quoteBalance, tradeApi, market) {
        const [minTotal, setMinTotal] = (0, react_1.useState)(0);
        (0, react_1.useEffect)(() => {
            if (!aiItem) {
                setMinTotal(0);
                return;
            }
            const minPerVolume = SimpleTrading_1.SimpleTrading.getMinAmount(symbol, aiItem.low) || 0;
            const subscribe = this.checkGridBalance(symbol, baseBalance, quoteBalance, aiItem.high, aiItem.low, minPerVolume, aiItem.grid_count, tradeApi, market).subscribe({
                next: (_data) => {
                    const data = _data;
                    const realNeedBase = trade_utils_lib_1.NumberCommonUtils.str2number(data.realNeedBase);
                    const realNeedQuote = trade_utils_lib_1.NumberCommonUtils.str2number(data.realNeedQuote);
                    const minTotal = realNeedBase * ticker.latest + realNeedQuote;
                    setMinTotal(minTotal);
                },
                error: (error) => {
                    setMinTotal(0);
                },
            });
            return () => {
                subscribe.unsubscribe();
            };
        }, [aiItem, symbol, baseBalance, quoteBalance]);
        return minTotal;
    },
    checkBalanceEnoughRequest(high, low, perVolume, gridCount, baseBalance, quoteBalance, $st, stop, minPerVolume, currentPrice) {
        if (!high || !low) {
            return TradeErrorConstants_1.TradeErrorConstants.inputPriceRange($st);
        }
        if (!gridCount) {
            return TradeErrorConstants_1.TradeErrorConstants.inputGridCount($st);
        }
        if (gridCount < 2 || gridCount > 99) {
            return TradeErrorConstants_1.TradeErrorConstants.gridCount99RangeError($st);
        }
        if (!perVolume) {
            return TradeErrorConstants_1.TradeErrorConstants.inputGridPerVolume($st);
        }
        if (!baseBalance && !quoteBalance) {
            return TradeErrorConstants_1.TradeErrorConstants.balanceNotEnough($st);
        }
        if (low >= high) {
            return TradeErrorConstants_1.TradeErrorConstants.gridCheckPriceRange($st);
        }
        if (stop && stop >= low) {
            return TradeErrorConstants_1.TradeErrorConstants.gridCheckPriceRange($st);
        }
        if (stop && currentPrice && stop >= currentPrice) {
            return TradeErrorConstants_1.TradeErrorConstants.stopCannotHighThanCurrentPrice($st);
        }
        if (minPerVolume && perVolume < minPerVolume) {
            return TradeErrorConstants_1.TradeErrorConstants.lowAmount(minPerVolume, $st);
        }
        return undefined;
    },
    transRequireBalanceErrMsg(errMsg, base, quote, $st) {
        if (errMsg === "error_row_is_not_illegal") {
            return TradeErrorConstants_1.TradeErrorConstants.gridCount99RangeError($st);
        }
        else if (errMsg === "error_per_volume_hit_amount_min") {
            return TradeErrorConstants_1.TradeErrorConstants.gridPerVolumeHitAmountMin($st);
        }
        else if (errMsg === "error_interval_price_too_small") {
            return TradeErrorConstants_1.TradeErrorConstants.gridPriceTooSmall($st);
        }
        else if (errMsg === "error_grid_price_hit_price_min") {
            return TradeErrorConstants_1.TradeErrorConstants.gridPriceRangeTooLarge($st);
        }
        else if (errMsg === "error_grid_cost_hit_cost_min") {
            return TradeErrorConstants_1.TradeErrorConstants.gridCostHitCostMin($st);
        }
        else if (errMsg === "error_init_grids_error") {
            return TradeErrorConstants_1.TradeErrorConstants.gridUnknownError($st);
        }
        else if (errMsg === "error_duplicate_grid") {
            return TradeErrorConstants_1.TradeErrorConstants.gridDuplicateGrid($st);
        }
        else if (errMsg === "error_price_is_too_broad") {
            return TradeErrorConstants_1.TradeErrorConstants.gridPriceRangeTooLarge($st);
        }
        else if (errMsg === "error_exchange_busy") {
            return TradeErrorConstants_1.TradeErrorConstants.gridExchangeBusy($st);
        }
        else if (errMsg === "error_sign_failed") {
            return TradeErrorConstants_1.TradeErrorConstants.gridSignFailed($st);
        }
        else if (errMsg === "error_price_is_too_high") {
            return TradeErrorConstants_1.TradeErrorConstants.gridPriceTooHigh($st);
        }
        else if (errMsg === "error_price_is_too_low") {
            return TradeErrorConstants_1.TradeErrorConstants.gridPriceTooSmall($st);
        }
        else if (errMsg === "error_balance_not_enough_both_side") {
            return TradeErrorConstants_1.TradeErrorConstants.balanceNotEnough($st);
        }
        else if (errMsg === "error_balance_not_enough_quote") {
            return TradeErrorConstants_1.TradeErrorConstants.quoteNotEnough(quote, $st);
        }
        else if (errMsg === "error_balance_not_enough_base") {
            return TradeErrorConstants_1.TradeErrorConstants.baseNotEnough(base, $st);
        }
        else if (errMsg === "error_in_get_balance") {
            return $st("grid_err_error_in_get_balance");
        }
        else if (errMsg === "error_in_place_grid_balance_order") {
            return $st("grid_err_error_balance_not_enough_both_side");
        }
        else if (errMsg === "error_in_wait_sell_grid_balance") {
            return $st("grid_err_error_in_wait_sell_grid_balance");
        }
        else if (errMsg === "error_in_grid_stop_loss") {
            return $st("grid_err_error_in_grid_stop_loss");
        }
        else if (errMsg === "error_in_cancel_orders") {
            return $st("grid_err_error_in_cancel_orders");
        }
        else if (errMsg === "error_in_place_grid_orders") {
            return $st("grid_err_error_in_place_grid_orders");
        }
        else if (errMsg === "error_in_wait_order_done") {
            return $st("grid_err_error_in_wait_order_done");
        }
        else if (errMsg === "error_none_balances_got") {
            return $st("grid_err_error_in_get_balance");
        }
        else if (errMsg === "error_got_none_check_grids") {
            return $st("grid_err_error_in_wait_order_done");
        }
        else if (errMsg === "error_not_found_cross_order") {
            return $st("grid_err_error_in_wait_order_done");
        }
        else if (errMsg === "error_got_none_cb_info") {
            return $st("grid_err_error_in_wait_order_done");
        }
        else if (errMsg === "error_got_unknown_cb_action") {
            return $st("grid_err_error_got_unknown_cb_action");
        }
        else if (errMsg === "error_add_not_balanced_monitor_error") {
            return $st("grid_err_error_add_not_balanced_monitor_error");
        }
        else if (errMsg === "error_add_balanced_monitor_error") {
            return $st("grid_err_error_add_balanced_monitor_error");
        }
        else if (errMsg === "error_stop_in_loss") {
            return $st("grid_err_error_stop_in_loss");
        }
        else if (errMsg === "error_balance_not_enough_in_run_time") {
            return $st("grid_err_error_balance_not_enough_in_run_time");
        }
        else if (errMsg === "error_got_unknown_order_id") {
            return $st("grid_err_error_got_unknown_order_id");
        }
        return errMsg;
    },
    useRequiredBalance(symbol, baseAvailable, quoteAvailable, high, low, perVolume, gridCount, price, tradeApi, market, $st) {
        const [requiredBalance, setRequiredBalance] = (0, react_1.useState)("-");
        const [requiredBalanceDesc, setRequiredBalanceDesc] = (0, react_1.useState)("-");
        const [loading, setLoading] = (0, react_1.useState)(false);
        const [error, setError] = (0, react_1.useState)("");
        (0, react_1.useEffect)(() => {
            const highNum = NumberTradeUtils_1.NumberTradeUtils.toPriceNumBySymbol(tradeApi, high, symbol);
            const lowNum = NumberTradeUtils_1.NumberTradeUtils.toPriceNumBySymbol(tradeApi, low, symbol);
            const perVNum = NumberTradeUtils_1.NumberTradeUtils.toAmountNumBySymbol(tradeApi, perVolume, symbol);
            const gridCountNum = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(gridCount, 0).toNumber();
            const localErr = this.checkBalanceEnoughRequest(highNum, lowNum, perVNum, gridCountNum, baseAvailable, quoteAvailable, $st);
            if (localErr) {
                setRequiredBalance("--");
                setRequiredBalanceDesc("");
                setLoading(false);
                setError("");
                return;
            }
            setLoading(true);
            const sub = this.checkGridBalance(symbol, baseAvailable, quoteAvailable, highNum, lowNum, perVNum, gridCountNum, tradeApi, market).subscribe({
                next: (data) => {
                    if (data.needBase !== "None" ||
                        data.needQuote !== "None" ||
                        data.realNeedBase !== "None" ||
                        data.realNeedQuote !== "None") {
                        const realNeedBase = trade_utils_lib_1.NumberCommonUtils.str2number(data.realNeedBase);
                        const realNeedQuote = trade_utils_lib_1.NumberCommonUtils.str2number(data.realNeedQuote);
                        const totalPrice = NumberTradeUtils_1.NumberTradeUtils.toPriceBySymbol(tradeApi, realNeedBase * price + realNeedQuote, symbol, decimal_js_1.default.ROUND_UP);
                        const totalPriceStr = `= ${totalPrice} ${symbol.quote.toUpperCase()}`;
                        const needBase = NumberTradeUtils_1.NumberTradeUtils.toAmountBySymbol(tradeApi, data.needBase, symbol, decimal_js_1.default.ROUND_UP);
                        const needQuote = NumberTradeUtils_1.NumberTradeUtils.toPriceBySymbol(tradeApi, data.needQuote, symbol, decimal_js_1.default.ROUND_UP);
                        const descStr = `(${needBase}${symbol.baseDisplay.toUpperCase()}+${needQuote}${symbol.quote.toUpperCase()})`;
                        setRequiredBalance(totalPriceStr);
                        setRequiredBalanceDesc(descStr);
                        setError("");
                    }
                    else {
                        setRequiredBalance("--");
                        setRequiredBalanceDesc("--");
                        setError(this.transRequireBalanceErrMsg(data.errMsg, symbol.baseDisplay, symbol.quote, $st));
                    }
                    setLoading(false);
                },
                error: (error) => {
                    setLoading(false);
                    setRequiredBalance("--");
                    setRequiredBalanceDesc("--");
                    setError(JSON.stringify(error) || `${error}`);
                },
            });
            return () => {
                if (sub) {
                    sub.unsubscribe();
                }
            };
        }, [symbol, baseAvailable, quoteAvailable, high, low, perVolume, gridCount, tradeApi, market, $st]);
        return [requiredBalance, requiredBalanceDesc, loading, error];
    },
    /**
     *
     * @param top
     * @param underlayPrice 标的价格， 有触发价则为触发价，没有则为当前价
     * @param bottom
     * @param $st
     */
    priceRangeComplianceCheck($st, underlayPrice, top, bottom, orderType) {
        let tempResult = true;
        let tempReason = undefined;
        if (top.lessThan(underlayPrice.div(10))) {
            tempResult = false;
            tempReason = {
                reason: $st("price_range_check_top_recommend"),
                type: PriceNonComplianceType.topNonCompliance,
            };
        }
        if (bottom.greaterThan(underlayPrice.mul(10))) {
            tempResult = false;
            tempReason = {
                reason: $st("price_range_check_bottom_recommend"),
                type: PriceNonComplianceType.bottomNonCompliance,
            };
        }
        if (!bottom.equals(0) && top.greaterThan(bottom.mul(100))) {
            tempResult = false;
            tempReason = {
                reason: $st("price_range_check_range_recommend"),
                type: PriceNonComplianceType.rangeNonCompliance,
            };
            if (orderType === TradeAPILib_1.ExchangeOrderType.gridV5) {
                const topBottomDiv = top.div(bottom);
                if (topBottomDiv.gte(1000)) {
                    tempReason.reason = $st("price_range_check_range_recommend_range_1000");
                }
                else if (topBottomDiv.gte(200)) {
                    tempReason.reason = $st("price_range_check_range_recommend_range_200");
                }
            }
        }
        return {
            result: tempResult,
            info: tempReason,
        };
    },
    checkSpotGridShowQuoteSwitchBar(order) {
        if (![TradeAPILib_1.ExchangeOrderType.gridV4, TradeAPILib_1.ExchangeOrderType.gridV5].includes(order.orderType)) {
            return false;
        }
        const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(order);
        // u为quote的的合约网格都不展示U本位切换按钮
        if (interface_1.StableCoin.includes(order.quote)) {
            return false;
        }
        // 条件单合约网格不显示u本位切换按钮
        if (innerOrder.isConditionAndNotTriggered) {
            return false;
        }
        if (order.isRunning) {
            // 运行中的非USDT为Quote的订单，当openQuotePrice有大于0的值时，我们可以计算出U本位的值，此时展示U本位切换按钮
            return !new trade_utils_lib_1.SafeDecimal(innerOrder.openQuotePrice).eq(0);
        }
        else {
            // 历史订单中的非USDT为Quote的订单，当openQuotePrice没有值时，我们直接不展示U本位切换按钮
            if (new trade_utils_lib_1.SafeDecimal(innerOrder.openQuotePrice).eq(0)) {
                return false;
            }
            const closeSellModel = innerOrder.close_sell_model;
            switch (closeSellModel) {
                case TradeAPILib_1.BotOrderCloseModel.TO_QUOTE: {
                    // 历史订单中的非USDT为Quote的订单，当closed_quote_price有值时，我们才展示U本位的切换按钮
                    return !new trade_utils_lib_1.SafeDecimal(innerOrder.closed_quote_price).eq(0);
                }
                case TradeAPILib_1.BotOrderCloseModel.TO_USDT: {
                    // 历史订单中的非USDT为Quote的订单，当quote_sell_price有值时，我们才展示U本位的切换按钮
                    return !new trade_utils_lib_1.SafeDecimal(innerOrder.quote_sell_price).eq(0);
                }
                default: {
                    // 默认展示U本位的切换按钮
                    return true;
                }
            }
        }
    },
    calcGridValuationInfo(params) {
        if (![TradeAPILib_1.ExchangeOrderType.gridV4, TradeAPILib_1.ExchangeOrderType.gridV5, TradeAPILib_1.ExchangeOrderType.martingale].includes(params.order.orderType)) {
            throw new Error("orderType are not supported");
        }
        const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(params.order);
        const [basePrice, quotePrice] = (() => {
            if (params.order.isRunning) {
                let tempBaseUPrice;
                if (params.baseUSDTPrice === undefined) {
                    tempBaseUPrice = new trade_utils_lib_1.SafeDecimal(params.baseQuotePrice).mul(new trade_utils_lib_1.SafeDecimal(params.quoteUSDTPrice)).toNumber();
                }
                else {
                    tempBaseUPrice = new trade_utils_lib_1.SafeDecimal(params.baseUSDTPrice).toNumber();
                }
                return [tempBaseUPrice, params.quoteUSDTPrice];
            }
            if (innerOrder.close_sell_model === TradeAPILib_1.BotOrderCloseModel.NOT_SELL) {
                return [innerOrder.closedPrice, innerOrder.closedQuotePrice];
            }
            if (innerOrder.close_sell_model === TradeAPILib_1.BotOrderCloseModel.TO_QUOTE) {
                return [innerOrder.base_sell_price, innerOrder.closedQuotePrice];
            }
            if (innerOrder.close_sell_model === TradeAPILib_1.BotOrderCloseModel.TO_USDT) {
                return [innerOrder.base_sell_price, innerOrder.quote_sell_price];
            }
            return [0, 0];
        })();
        const initBaseForUPrice = new trade_utils_lib_1.SafeDecimal(innerOrder.openPrice).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.openQuotePrice));
        const tempInitValueForU = initBaseForUPrice
            .mul(new trade_utils_lib_1.SafeDecimal(innerOrder.initBaseAmount))
            .add(new trade_utils_lib_1.SafeDecimal(innerOrder.openQuotePrice).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.initQuoteAmount)));
        let initValueForU = new trade_utils_lib_1.SafeDecimal(0);
        if (params.order.orderType === TradeAPILib_1.ExchangeOrderType.gridV4) {
            initValueForU = "USDT" === innerOrder.invest_coin ? new trade_utils_lib_1.SafeDecimal(innerOrder.usdt_investment) : tempInitValueForU;
        }
        else {
            initValueForU = new trade_utils_lib_1.SafeDecimal(innerOrder.usdt_investment).greaterThan(0)
                ? new trade_utils_lib_1.SafeDecimal(innerOrder.usdt_investment)
                : tempInitValueForU;
        }
        let currentBaseForUPrice = new trade_utils_lib_1.SafeDecimal(0);
        if (params.order.isRunning) {
            currentBaseForUPrice = new trade_utils_lib_1.SafeDecimal(basePrice);
        }
        else {
            if (innerOrder.close_sell_model === TradeAPILib_1.BotOrderCloseModel.TO_USDT) {
                currentBaseForUPrice = new trade_utils_lib_1.SafeDecimal(basePrice);
            }
            else {
                currentBaseForUPrice = new trade_utils_lib_1.SafeDecimal(basePrice).mul(new trade_utils_lib_1.SafeDecimal(quotePrice));
            }
        }
        const currentValueForU = currentBaseForUPrice
            .mul(new trade_utils_lib_1.SafeDecimal(innerOrder.baseAmount))
            .add(new trade_utils_lib_1.SafeDecimal(quotePrice).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.quoteAmount)))
            .add(new trade_utils_lib_1.SafeDecimal(innerOrder.unlock_usdt_amount));
        const pnlByUsdt = currentValueForU.sub(initValueForU);
        const pnlPercent = initValueForU.equals(0) ? 0 : pnlByUsdt.mul(100).div(initValueForU).toNumber();
        const gridProfitU = new trade_utils_lib_1.SafeDecimal(innerOrder.gridProfit).mul(new trade_utils_lib_1.SafeDecimal(quotePrice));
        const gridProfitUPercent = initValueForU.equals(0) ? 0 : gridProfitU.mul(100).div(initValueForU).toNumber();
        const unRealizedProfitU = pnlByUsdt.sub(gridProfitU);
        const unRealizedProfitUPercent = initValueForU.equals(0) ? 0 : unRealizedProfitU.mul(100).div(initValueForU).toNumber();
        const profitWithdrawnQuote = new trade_utils_lib_1.SafeDecimal(innerOrder.profitWithdrawn).sub(new trade_utils_lib_1.SafeDecimal(innerOrder.profit_reinvest));
        const profitWithdrawnU = profitWithdrawnQuote.mul(new trade_utils_lib_1.SafeDecimal(quotePrice));
        const accumulativePnlByU = currentValueForU.add(new trade_utils_lib_1.SafeDecimal(profitWithdrawnU)).sub(initValueForU);
        const accumulativePnlPercentByU = initValueForU.equals(0) ? 0 : accumulativePnlByU.mul(100).div(initValueForU).toNumber();
        const accumulativeGridPnlU = new trade_utils_lib_1.SafeDecimal(innerOrder.gridProfitOriginal).mul(new trade_utils_lib_1.SafeDecimal(quotePrice));
        const accumulativeGidPnlPercentByU = initValueForU.equals(0) ? 0 : accumulativeGridPnlU.mul(100).div(initValueForU).toNumber();
        return {
            usdtValuation: {
                initValue: initValueForU.toNumber(),
                totalProfit: pnlByUsdt.toNumber(),
                totalProfitPercent: pnlPercent,
                gridProfit: gridProfitU.toNumber(),
                gridProfitPercent: gridProfitUPercent,
                unRealizedProfit: unRealizedProfitU.toNumber(),
                unrealizedProfitPercent: unRealizedProfitUPercent,
                accumulativePNLInfo: {
                    accumulativePnl: accumulativePnlByU.toNumber(),
                    accumulativePnlPercent: accumulativePnlPercentByU,
                    accumulativeGridPnl: accumulativeGridPnlU.toNumber(),
                    accumulativeGridPnlPercent: accumulativeGidPnlPercentByU, //累计套利总利润百分比
                },
                profitWithdrawn: profitWithdrawnU.toNumber(),
                profitReinvest: new trade_utils_lib_1.SafeDecimal(innerOrder.profit_reinvest).mul(new trade_utils_lib_1.SafeDecimal(quotePrice)).toNumber(),
            },
            quoteValuation: exports.GridUtils.calcGridQuoteValuationInfo(params.order),
        };
    },
    calcGridQuoteValuationInfo(order) {
        const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(order);
        const profitWithdrawnQuote = new trade_utils_lib_1.SafeDecimal(innerOrder.profitWithdrawn).sub(new trade_utils_lib_1.SafeDecimal(innerOrder.profit_reinvest));
        const accumulativePnl = new trade_utils_lib_1.SafeDecimal(innerOrder.totalProfit).add(new trade_utils_lib_1.SafeDecimal(profitWithdrawnQuote));
        const accumulativePnlPercent = new trade_utils_lib_1.SafeDecimal(innerOrder.totalCost).equals(0)
            ? 0
            : accumulativePnl.mul(100).div(new trade_utils_lib_1.SafeDecimal(innerOrder.totalCost)).toNumber();
        const accumulativeGridPnl = new trade_utils_lib_1.SafeDecimal(innerOrder.gridProfitOriginal);
        const accumulativeGidPnlPercent = new trade_utils_lib_1.SafeDecimal(innerOrder.totalCost).equals(0)
            ? 0
            : accumulativeGridPnl.mul(100).div(new trade_utils_lib_1.SafeDecimal(innerOrder.totalCost)).toNumber();
        return {
            initValue: innerOrder.totalCost,
            totalProfit: innerOrder.totalProfit,
            totalProfitPercent: innerOrder.totalProfitPercent,
            gridProfit: innerOrder.gridProfit,
            gridProfitPercent: innerOrder.gridProfitPercent,
            unRealizedProfit: innerOrder.unRealizedProfit,
            unrealizedProfitPercent: innerOrder.unrealizedProfitPercent,
            accumulativePNLInfo: {
                accumulativePnl: accumulativePnl.toNumber(),
                accumulativePnlPercent: accumulativePnlPercent,
                accumulativeGridPnl: accumulativeGridPnl.toNumber(),
                accumulativeGridPnlPercent: accumulativeGidPnlPercent, //累计套利总利润百分比
            },
            profitWithdrawn: profitWithdrawnQuote.toNumber(),
            profitReinvest: Number(innerOrder.profit_reinvest),
        };
    },
    // 止盈价格检查
    // 做多： 输入的价格是当前价格的10倍时，提示用户止盈价格过远的提示
    // 做空： 输入的价格是当前价格的1/10时, 则提示用户止盈价格过远的提示
    tpPriceCheck({ $st, userPrice, currentPrice, trend, }) {
        const u = new trade_utils_lib_1.SafeDecimal(userPrice);
        const t = new trade_utils_lib_1.SafeDecimal(currentPrice);
        const priceRes = u.div(t);
        if (trend === TradeAPILib_1.GridFuturesTrend.long && priceRes.gt(UP_PRICE_RATIO)) {
            return {
                result: false,
                info: {
                    type: PriceNonComplianceType.tpNonCompliance,
                    reason: $st("grid_futures_price_tip_tp_long_err_msg", { diff: priceRes.toDP(2, trade_utils_lib_1.SafeDecimal.ROUND_HALF_UP).toFixed() }),
                },
            };
        }
        else if (trend === TradeAPILib_1.GridFuturesTrend.short && priceRes.lt(DOWN_PRICE_RATIO)) {
            return {
                result: false,
                info: {
                    type: PriceNonComplianceType.tpNonCompliance,
                    reason: $st("grid_futures_price_tip_tp_short_err_msg", {
                        diff: priceRes.toDP(4, trade_utils_lib_1.SafeDecimal.ROUND_HALF_UP).mul(100).toFixed(),
                    }),
                },
            };
        }
        else {
            return {
                result: true,
                info: undefined,
            };
        }
    },
    // 止损价格检查
    // 做多： 输入的价格是当前价格的1/10时，提示用户止损价格过远的提示
    // 做空： 输入的价格是当前价格的10倍时, 则提示用户止损价格过远的提示
    slPriceCheck({ $st, userPrice, currentPrice, trend, }) {
        const u = new trade_utils_lib_1.SafeDecimal(userPrice);
        const t = new trade_utils_lib_1.SafeDecimal(currentPrice);
        const priceRes = u.div(t);
        if (trend === TradeAPILib_1.GridFuturesTrend.long && priceRes.lt(DOWN_PRICE_RATIO)) {
            return {
                result: false,
                info: {
                    type: PriceNonComplianceType.slNonCompliance,
                    reason: $st("grid_futures_price_tip_sl_long_err_msg", {
                        diff: priceRes.toDP(4, trade_utils_lib_1.SafeDecimal.ROUND_HALF_UP).mul(100).toFixed(),
                    }),
                },
            };
        }
        else if (trend === TradeAPILib_1.GridFuturesTrend.short && priceRes.gt(UP_PRICE_RATIO)) {
            return {
                result: false,
                info: {
                    type: PriceNonComplianceType.slNonCompliance,
                    reason: $st("grid_futures_price_tip_sl_short_err_msg", { diff: priceRes.toDP(2, trade_utils_lib_1.SafeDecimal.ROUND_HALF_UP).toFixed() }),
                },
            };
        }
        else {
            return {
                result: true,
                info: undefined,
            };
        }
    },
    // 触发价格检查
    // 输入的价格是当前价格的10倍时，或 输入的价格是当前价格的1/10时, 则提示用户触发价格过远的提示
    triggerPriceCheck({ $st, userPrice, currentPrice }) {
        const u = new trade_utils_lib_1.SafeDecimal(userPrice);
        const t = new trade_utils_lib_1.SafeDecimal(currentPrice);
        const priceRes = u.div(t);
        if (priceRes.gt(UP_PRICE_RATIO)) {
            return {
                result: false,
                info: {
                    type: PriceNonComplianceType.triggerPriceNonCompliance,
                    reason: $st("grid_futures_price_tip_trigger_long_err_msg", {
                        diff: priceRes.toDP(2, trade_utils_lib_1.SafeDecimal.ROUND_HALF_UP).toFixed(),
                    }),
                },
            };
        }
        else if (priceRes.lt(DOWN_PRICE_RATIO)) {
            return {
                result: false,
                info: {
                    type: PriceNonComplianceType.triggerPriceNonCompliance,
                    reason: $st("grid_futures_price_tip_trigger_short_err_msg", {
                        diff: priceRes.toDP(4, trade_utils_lib_1.SafeDecimal.ROUND_HALF_UP).mul(100).toFixed(),
                    }),
                },
            };
        }
        else {
            return {
                result: true,
                info: undefined,
            };
        }
    },
    /**
     *
     * @param top
     * @param currentPrice 标的当前价
     * @param bottom
     * @param $st
     */
    gfPriceRangeComplianceCheck({ $st, currentPrice, top, bottom, }) {
        const input_top = new trade_utils_lib_1.SafeDecimal(top);
        const input_bottom = new trade_utils_lib_1.SafeDecimal(bottom);
        const price = new trade_utils_lib_1.SafeDecimal(currentPrice);
        const upPriceDiff = input_top.div(price);
        const bottomPriceDiff = input_bottom.div(price);
        if (bottomPriceDiff.gt(UP_PRICE_RATIO)) {
            return {
                result: false,
                info: {
                    type: PriceNonComplianceType.bottomNonCompliance,
                    reason: $st("grid_futures_price_tip_bottom_err_msg", {
                        diff: bottomPriceDiff.toDP(2, trade_utils_lib_1.SafeDecimal.ROUND_HALF_UP).toFixed(),
                    }),
                },
            };
        }
        else if (upPriceDiff.lt(DOWN_PRICE_RATIO)) {
            return {
                result: false,
                info: {
                    type: PriceNonComplianceType.topNonCompliance,
                    reason: $st("grid_futures_price_tip_top_err_msg", {
                        diff: upPriceDiff.toDP(4, trade_utils_lib_1.SafeDecimal.ROUND_HALF_UP).mul(100).toFixed(),
                    }),
                },
            };
        }
        else if (!input_bottom.equals(0) && input_top.greaterThan(input_bottom.mul(100))) {
            let r = $st("price_range_check_range_recommend");
            const topBottomDiv = input_top.div(input_bottom);
            if (topBottomDiv.gte(1000)) {
                r = $st("price_range_check_range_recommend_range_1000");
            }
            else if (topBottomDiv.gte(200)) {
                r = $st("price_range_check_range_recommend_range_200");
            }
            return {
                result: false,
                info: {
                    type: PriceNonComplianceType.rangeNonCompliance,
                    reason: r,
                },
            };
        }
        return {
            result: true,
            info: undefined,
        };
    },
    // 计算订单持续时间
    getFormatTimeLasting(timeInterval) {
        let chaTime = timeInterval;
        const day = 1000 * 60 * 60 * 24; // 一天等于毫秒数
        const hour = 1000 * 60 * 60; // 一小时等于毫秒数
        const dayResult = Math.floor(chaTime / day); //
        chaTime = chaTime - dayResult * day; // 减去天的毫秒数。再求小时个数
        const hourResult = Math.floor(chaTime / hour);
        chaTime = chaTime - hourResult * hour; // 减去小时的毫秒数。再求分钟个数
        const minuteResult = Math.floor(chaTime / (1000 * 60));
        const secondResult = Math.floor((chaTime - minuteResult * 1000 * 60) / 1000); // 减去分钟的毫秒数。再求秒的个数
        return {
            day: dayResult,
            hour: hourResult,
            minute: minuteResult,
            second: secondResult,
        };
    },
    // 订单持续时间展示简化版本
    // https://pionex.atlassian.net/browse/BOT-382
    getOrderLastingTimeShortVersion(isRunning, timestamp, $st, isConditionAndNotTriggered, triggerTime, closeTimestamp, label, displayingSecond) {
        let tempLastingTime = "--";
        const formatTimeResult = (timeResult) => {
            const minContent = `${timeResult.minute}${$st("grid_order_lasting_minute")}`;
            const secondStr = `${timeResult.second}${$st("grid_order_lasting_second")}`;
            const dayStr = new trade_utils_lib_1.SafeDecimal(timeResult.day).gt(0) ? `${timeResult.day}${$st("grid_order_lasting_day")} ` : "";
            const hourStr = new trade_utils_lib_1.SafeDecimal(timeResult.hour).gt(0) ? `${timeResult.hour}${$st("grid_order_lasting_hour")} ` : "";
            const minuteStr = new trade_utils_lib_1.SafeDecimal(timeResult.minute).gt(0) ? `${minContent} ` : "";
            if (displayingSecond) {
                return `${dayStr}${hourStr}${minuteStr}${secondStr}`;
            }
            else {
                return `${dayStr}${hourStr}${minContent}`;
            }
        };
        if (isRunning) {
            if (isConditionAndNotTriggered) {
                tempLastingTime = `${$st("grid_order_isnot_running")}`;
            }
            else {
                let startTime = timestamp;
                if (triggerTime !== undefined) {
                    startTime = triggerTime;
                }
                const endTime = new Date().getTime();
                const lasting = endTime - startTime;
                const defaultZero = trade_utils_lib_1.NumberCommonUtils.complementDigit(0, 2);
                let hourDisplay = defaultZero;
                let dayDisplay = defaultZero;
                let minuteDisplay = defaultZero;
                let secondDisplay = defaultZero;
                if (lasting > 0) {
                    const timeResult = exports.GridUtils.getFormatTimeLasting(lasting);
                    dayDisplay = timeResult.day.toString();
                    hourDisplay = trade_utils_lib_1.NumberCommonUtils.complementDigit(timeResult.hour, 1);
                    minuteDisplay = trade_utils_lib_1.NumberCommonUtils.complementDigit(timeResult.minute, 1);
                    secondDisplay = trade_utils_lib_1.NumberCommonUtils.complementDigit(timeResult.second, 1);
                }
                tempLastingTime = `${label ? label : $st("lasting")} ${formatTimeResult({
                    day: dayDisplay,
                    hour: hourDisplay,
                    minute: minuteDisplay,
                    second: secondDisplay,
                })}`;
            }
        }
        else {
            let startTime = timestamp;
            if (triggerTime !== undefined) {
                startTime = triggerTime;
            }
            const lasting = closeTimestamp - startTime;
            const defaultZero = trade_utils_lib_1.NumberCommonUtils.complementDigit(0, 2);
            let hourDisplay = defaultZero;
            let dayDisplay = defaultZero;
            let minuteDisplay = defaultZero;
            let secondDisplay = defaultZero;
            if (lasting > 0) {
                const timeResult = exports.GridUtils.getFormatTimeLasting(lasting);
                dayDisplay = timeResult.day.toString();
                hourDisplay = trade_utils_lib_1.NumberCommonUtils.complementDigit(timeResult.hour, 1);
                minuteDisplay = trade_utils_lib_1.NumberCommonUtils.complementDigit(timeResult.minute, 1);
                secondDisplay = trade_utils_lib_1.NumberCommonUtils.complementDigit(timeResult.second, 1);
            }
            tempLastingTime = `${label ? label : $st("lasting")} ${formatTimeResult({
                day: dayDisplay,
                hour: hourDisplay,
                minute: minuteDisplay,
                second: secondDisplay,
            })}`;
        }
        return tempLastingTime;
    },
};
